import Dexie, { Table } from 'dexie';

export interface OfflineEntityRow {
  key: string;
  data: unknown;
  updatedAt: number;
  ttlMs?: number;
  serverSkewMs?: number;
}

export interface OfflineOutboxRow {
  id?: number;
  method: 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  url: string;
  body?: unknown;
  entityKey?: string;
  entityId?: string;
  blobIds?: string[];
  idempotencyKey: string;
  createdAt: number;
  attempts: number;
  lastError?: string;
  kind?: 'api' | 'multipart' | 'notify' | 'gcs-put';
}

export interface OfflineBlobRow {
  id: string;
  mimeType: string;
  fileName: string;
  bytes: ArrayBuffer;
  createdAt: number;
  previewUrl?: string;
}

export interface OfflineMetaRow {
  key: string;
  value: unknown;
}

export class OfflineDb extends Dexie {
  entities!: Table<OfflineEntityRow, string>;
  outbox!: Table<OfflineOutboxRow, number>;
  blobs!: Table<OfflineBlobRow, string>;
  meta!: Table<OfflineMetaRow, string>;

  constructor() {
    super('webddn-offline-v1');
    this.version(1).stores({
      entities: 'key, updatedAt',
      outbox: '++id, createdAt, entityKey, entityId, idempotencyKey',
      blobs: 'id, createdAt',
      meta: 'key',
    });
  }
}

export const offlineDb = new OfflineDb();
